module.exports = __webpack_public_path__ + "static/media/norrkoping.80b85c02.png";